import { gql } from "@apollo/client";
import FormText from "controls/FormText";
import useData from "hooks/useData";
import useIsAdmin from "hooks/useIsAdmin";
import { DeleteForever, Mail, Trophy } from "mdi-material-ui";
import React from "react";
import makeConfirmActionDialog from "readmin_pages/shared/makeConfirmActionDialog";

export const GamesEnablePotwDialog = makeConfirmActionDialog({
  mutationName: "gamesEnablePotw",
  fragment: "games { id potwEnabled }",
  paramName: "gameIds",
  action: "Enable Plays of the Week",
  useButtonProps: ({ gameIds }) => {
    const [data] = useData(
      gql`
        query GamesEnablePotwDialog($gameIds: [ID!]!) {
          games(ids: $gameIds) {
            id
            potwEnabled
            league {
              id
              potwEnabled
            }
          }
        }
      `,
      { gameIds },
    );

    return {
      icon: <Trophy />,
      hidden: !data?.games.some((game) => !game.potwEnabled && game.league.potwEnabled),
      content: "Enable Plays of the Week",
    };
  },
});

export const GamesDisablePotwDialog = makeConfirmActionDialog({
  mutationName: "gamesDisablePotw",
  fragment: "games { id potwEnabled }",
  paramName: "gameIds",
  action: "Disable Plays of the Week",
  useButtonProps: ({ gameIds }) => {
    const [data] = useData(
      gql`
        query GamesDisablePotwDialog($gameIds: [ID!]!) {
          games(ids: $gameIds) {
            id
            potwEnabled
          }
        }
      `,
      { gameIds },
    );

    return {
      icon: <Trophy />,
      hidden: !data?.games.some((game) => game.potwEnabled),
      content: "Disable Plays of the Week",
    };
  },
});

export const GamesDeleteDialog = makeConfirmActionDialog({
  mutationName: "gamesDelete",
  paramName: "gameIds",
  action: "Delete Games",
  useButtonProps: () => {
    const isAdmin = useIsAdmin();
    return {
      icon: <DeleteForever />,
      hidden: !isAdmin,
      content: "Delete Games",
    };
  },
  useConfirmFormDialogProps: () => {
    return {
      typeToConfirm: true,
      children: <FormText uiStringKey="readmin.game.remove_games_confirm" />,
    };
  },
});

export const ResendGameNotificationDialog = makeConfirmActionDialog({
  mutationName: "resendGameNotification",
  paramName: "gameIds",
  action: "Resend Game Notification to All Participants",
  useButtonProps: () => {
    const isAdmin = useIsAdmin();
    return {
      icon: <Mail />,
      hidden: !isAdmin,
      content: "Resend Game Notification",
    };
  },
});
